import React, { useState, useEffect } from "react";
import "../style/cajas.css";
import Titulo from "../components/titulos";
import FeedIcon from "@mui/icons-material/Feed";
import { getAlbaranes } from "../service/apiAlbaran";
import { getProveedores } from "../service/apiProveedores";
import { getSeries } from "../service/apiSeries";
import {
  Box,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Button,
  MenuItem,
  TextField,
  Select,
  InputLabel,
  FormControl,
  TableBody,
} from "@mui/material";
import { use } from "react";
import { getAlbaranesExport } from "../service/apiAlbaran";
import format from "date-fns/format";
import * as XLSX from "xlsx";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const Informes = () => {
  const [data, setData] = useState([]);
  const [tipoCliente, setTipoCliente] = useState("");
  const [proveedor, setProveedor] = useState("");
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const [proveedores, setProveedores] = useState([]);
  const [series, setSeries] = useState([]);
  const [albaranes, setAlbaranes] = useState([]);
  const celdas = [
    "Consecutivo",
    "Fecha",
    "Serie",
    "REF",
    "Albarán Entrada",
    "Código",
    "Matrícula",
    "Metodo Pago",
    "Almacen",
    "Estado",
    "Proveedor",
    "Residuo",
    "Codigo LER",
    "Cantidad (Kg)",
    "Precio por Almacén",
    "IVA",
    "Subtotal",
    "Total Línea",
    "Peso Entrada",
    "Peso Salida",
    "Peso Final",
  ];
  const [sortConfig, setSortConfig] = useState({
    key: "Consecutivo",
    direction: "asc",
  });
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getAlbaranes();
        setData(response);
      } catch (error) {
        console.error("Error fetching albaranes:", error);
      }
    };
    const fetchProveedores = async () => {
      try {
        const response = await getProveedores();
        setProveedores(response);
      } catch (error) {
        console.error("Error fetching proveedores:", error);
      }
    };
    const fetchSeries = async () => {
      try {
        const response = await getSeries();
        setSeries(response);
      } catch (error) {
        console.error("Error fetching series:", error);
      }
    };
    const fetchAlbaranes = async () => {
      try {
        const response = await getAlbaranesExport();
        setAlbaranes(response);
      } catch (error) {
        console.error("Error fetching albaranes:", error);
      }
    };
    fetchAlbaranes();
    fetchSeries();
    fetchProveedores();
    fetchData();
  }, []);

  const handleDescargar = () => {
    if (albaranesFiltrados.length === 0) {
      alert("No hay albaranes que coincidan con los filtros aplicados.");
      return;
    }
    const worksheet = XLSX.utils.json_to_sheet(albaranesFiltrados);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Albaranes");
    XLSX.writeFile(workbook, "informe_albaranes.xlsx");
  };

  const handleDescargarFormatoInformes = () => {
    const datos = [
      {
        "Nombre de la Tarifa": "",
        "Residuo - Identificador": "",
        "Residuo - Descripción libre": "",
        "Contenedor - Id": "",
        "Contenedor - Descripción": "",
        "Producto - Id": "",
        "Producto - Descripción": "",
        "Servicio - Id": "",
        "Servicio - Descripción": "",
        "Fecha de inicio": "",
        "Fecha de fin": "",
        "Tipo de precio (entrada)": "",
        "Precio (entrada)": "",
        "Ud. medida (entrada)": "",
        "IVA (entrada)": "",
        "Tipo de precio (salida)": "",
        "Precio (salida)": "",
        "Ud. medida (salida)": "",
        "IVA (salida)": "",
      },
    ];
    const worksheet = XLSX.utils.json_to_sheet(datos);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Datos");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "estructuraTarifa.xlsx";
    link.click();

    URL.revokeObjectURL(url);
  };
  let albaranesFiltrados = [];

  const inicio = fechaInicio ? new Date(fechaInicio) : null;
  const fin = fechaFin ? new Date(fechaFin) : null;

  // Validar rango de fechas
  if (inicio && fin && inicio > fin) {
    alert("La fecha de inicio no puede ser mayor que la fecha final.");
  } else {
    albaranesFiltrados = albaranes.filter((a) => {
      const fechaAlbaran = new Date(a.Fecha);

      const porSerie =
        tipoCliente && tipoCliente !== "Todos" ? a.Serie === tipoCliente : true;

      const porProveedor =
        proveedor && proveedor !== "Todos" ? a.Proveedor === proveedor : true;

      const porFecha =
        (!inicio || fechaAlbaran >= inicio) && (!fin || fechaAlbaran <= fin);

      return porSerie && porProveedor && porFecha;
    });
  }

  const sortableKeys = ["Consecutivo", "Fecha", "Proveedor"];
  const handleSort = (key) => {
    setSortConfig((prevConfig) => {
      const newDirection =
        prevConfig.key === key && prevConfig.direction === "asc"
          ? "desc"
          : "asc";
      const sorted = [...albaranesFiltrados].sort((a, b) => {
        if (a[key] < b[key]) return newDirection === "asc" ? -1 : 1;
        if (a[key] > b[key]) return newDirection === "asc" ? 1 : -1;
        return 0;
      });
      setAlbaranes(sorted);
      return { key, direction: newDirection };
    });
  };
  return (
    <>
      <Titulo type="informe" name="Informes" />
      <Box className="container">
        {/* Filtros */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          gap={1}
          flexWrap="wrap"
          margin={"20px auto"}
        >
          <FormControl size="small" sx={{ minWidth: 230 }}>
            <InputLabel id="tipo-cliente-label">Serie Albarán</InputLabel>
            <Select
              sx={{
                minWidth: 230,
                maxWidth: 230,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
              labelId="tipo-cliente-label"
              value={tipoCliente}
              onChange={(e) => setTipoCliente(e.target.value)}
              label="Serie Albarán"
            >
              <MenuItem value="">-- Seleccionar serie --</MenuItem>
              {series.map((serie) => (
                <MenuItem key={serie.ser_id} value={serie.ser_tipo}>
                  {serie.ser_tipo}
                </MenuItem>
              ))}
              <MenuItem value="Todos">Todos</MenuItem>
            </Select>
          </FormControl>
          <FormControl size="small" sx={{ minWidth: 230 }}>
            <InputLabel>Proveedor</InputLabel>
            <Select
              sx={{
                minWidth: 230,
                maxWidth: 230,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
              value={proveedor}
              onChange={(e) => setProveedor(e.target.value)}
              label="Proveedor"
            >
              <MenuItem value="">-- Seleccionar proveedor --</MenuItem>
              {proveedores.map((prov) => (
                <MenuItem key={prov.prov_id} value={prov.prov_nombre}>
                  {prov.prov_nombre}
                </MenuItem>
              ))}
              <MenuItem value="Todos">Todos</MenuItem>
            </Select>
          </FormControl>
          <TextField
            size="small"
            label="Fecha Inicio"
            sx={{
              minWidth: 230,
              maxWidth: 230,
            }}
            type="date"
            InputLabelProps={{ shrink: true }}
            value={fechaInicio}
            onChange={(e) => setFechaInicio(e.target.value)}
          />
          <TextField
            size="small"
            label="Fecha Fin"
            sx={{
              minWidth: 230,
              maxWidth: 230,
            }}
            type="date"
            InputLabelProps={{ shrink: true }}
            value={fechaFin}
            onChange={(e) => setFechaFin(e.target.value)}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={handleDescargar}
            sx={{ alignSelf: "center", border: "1px solid #b5b5b5" }}
            className="btnFiltro"
          >
            Descargar
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleDescargarFormatoInformes}
            sx={{ alignSelf: "center", border: "1px solid #b5b5b5" }}
            className="btnFiltro"
          >
            Descargar Tarifa
          </Button>
        </Box>

        {/* Tabla */}
        <Box className="containerTablas">
          <TableContainer component={Paper} className="tableContainer">
            <Table>
              <TableHead>
                <TableRow>
                  {celdas.map((header) => (
                    <TableCell
                      onClick={() => handleSort(header)}
                      className="tableHeaderCell"
                      key={header}
                    >
                      {header}
                      {sortableKeys.includes(header) &&
                        (sortConfig.key === header &&
                        sortConfig.direction === "desc" ? (
                          <ArrowDropUpIcon className="headerTableIcons" />
                        ) : (
                          <ArrowDropDownIcon className="headerTableIcons" />
                        ))}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {albaranesFiltrados.map((albaran, index) => (
                  <TableRow key={index}>
                    <TableCell>{albaran.Consecutivo}</TableCell>
                    <TableCell>
                      {format(new Date(albaran.Fecha), "dd/MM/yyyy")}
                    </TableCell>
                    <TableCell>{albaran.Serie}</TableCell>
                    <TableCell>{albaran.REF}</TableCell>
                    <TableCell>{albaran["Albarán Entrada"]}</TableCell>
                    <TableCell>{albaran["Código"]}</TableCell>
                    <TableCell>{albaran["Matrícula"]}</TableCell>
                    <TableCell>{albaran["Metodo Pago"]}</TableCell>
                    <TableCell>{albaran.Almacen}</TableCell>
                    <TableCell>{albaran.Estado}</TableCell>
                    <TableCell>{albaran.Proveedor}</TableCell>
                    <TableCell>{albaran.Residuo}</TableCell>
                    <TableCell>{albaran["Codigo LER"]}</TableCell>
                    <TableCell>{albaran["Cantidad (Kg)"]}</TableCell>
                    <TableCell>{albaran["Precio por Almacén"]}</TableCell>
                    <TableCell>{albaran.IVA}</TableCell>
                    <TableCell>{albaran.Subtotal}</TableCell>
                    <TableCell>{albaran["Total Línea"]}</TableCell>
                    <TableCell>{albaran["Peso Entrada"]}</TableCell>
                    <TableCell>{albaran["Peso Salida"]}</TableCell>
                    <TableCell>{albaran["Peso Final"]}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    </>
  );
};

export default Informes;
